import { render, staticRenderFns } from "./RegistrationAction.vue?vue&type=template&id=6038b522&scoped=true&"
import script from "./RegistrationAction.vue?vue&type=script&lang=js&"
export * from "./RegistrationAction.vue?vue&type=script&lang=js&"
import style0 from "./RegistrationAction.vue?vue&type=style&index=0&id=6038b522&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6038b522",
  null
  
)

export default component.exports